export default {"src":"/_next/static/media/budget-in-principle.66ec91d6.svg","height":587,"width":589};